{
  "_provenance": {
    "ns": "onboarding",
    "source": "the onboarding wizard, banner, first-run card, guide chip and welcome banner: components/onboarding/** (#2109 R3 lane L1)"
  },
  "banner": {
    "dismiss": "Dismiss setup banner",
    "eyebrow": "Continue setup",
    "percentComplete": "{{percent}}% complete",
    "progress": {
      "almost": "{{done}} of {{total}} steps done — next, almost there.",
      "firstTask": "{{done}} of {{total}} steps done — next, add your first task.",
      "mfa": "{{done}} of {{total}} steps done — next, enable two-factor sign-in.",
      "patient": "{{done}} of {{total}} steps done — next, add your patient details.",
      "voice": "{{done}} of {{total}} steps done — next, choose {{companion}}'s voice."
    },
    "title": "Finish setting up {{companion}}"
  },
  "firstRun": {
    "chat": "Chat with {{companion}}",
    "dashboard": {
      "body": "Your case manager will reach out shortly. In the meantime, feel free to update your profile or chat with {{companion}}.",
      "title": "Your space is being set up"
    },
    "tasks": {
      "body": "Your space is being set up — your case manager will reach out shortly. Once your family is ready, you can add tasks and keep track of them on this page.",
      "title": "Tasks will appear here soon"
    },
    "updateProfile": "Update profile"
  },
  "guide": {
    "clickNav": "Click <strong>{{nav}}</strong> here",
    "clickRequest": "Tap <strong>Add a task</strong> to put something on your family’s list.",
    "skippedTitle": "Setup step skipped",
    "tapMore": "Tap <strong>{{more}}</strong>, then <strong>{{nav}}</strong>",
    "tasksSkipped": "You can create tasks anytime from the {{nav}} tab."
  },
  "welcome": {
    "body": "Welcome to TRF Imagine. By continuing to use this platform you agree to our <terms>Terms</terms>, <privacy>Privacy Notice</privacy>, and <ai>AI Use & Limitations</ai>.",
    "review": "Review"
  },
  "wizard": {
    "actions": {
      "continue": "Continue →",
      "gotIt": "Got it →",
      "maybeLater": "Maybe later",
      "skip": "Skip this step"
    },
    "clickInSidebar": "Click <strong>{{nav}}</strong> in the sidebar on the left",
    "done": {
      "about": "About {{companion}}",
      "aboutBody": "{{companion}} is your AI companion — available 24/7 by voice or text to answer questions and keep your tasks organised. You’ll find {{companion}} on Today whenever you need it.",
      "chat": "Chat with {{companion}} →",
      "goToDashboard": "Go to dashboard",
      "intro": "Here’s what we set up together — quietly, behind the scenes.",
      "patientAdded": "Patient info added",
      "taskCreated": "First task created"
    },
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "invalidCode": "Invalid code. Please try again.",
      "sendCode": "Couldn’t send the code. Please try again."
    },
    "exit": {
      "back": "Go back",
      "body": "You can finish it later from your dashboard.",
      "confirm": "Yes, exit setup",
      "title": "Exit setup?"
    },
    "exitLink": "Exit setup →",
    "firstTask": {
      "intro": "One small ask. We’ll walk you through adding a task on the {{nav}} tab.",
      "note": "Tasks can also be created in the <strong>{{nav}}</strong> — click any day or use the Add Task button.",
      "openNav": "Open the {{nav}} tab",
      "requestBody": "Put something on your family’s list: fill in the details and add it.",
      "requestTitle": "Tap “Add a task”"
    },
    "mfa": {
      "codeSent": "We sent a 6-digit code to your email. Enter it below to finish.",
      "enable": "Enable Two-Factor Authentication",
      "howItWorks": "How it works",
      "howItWorksBody": "A one-time code goes to your email or phone each time you sign in. Quick to enter, hard to bypass — and your family’s data stays private.",
      "intro": "Add two-factor authentication to protect your account.",
      "sending": "Sending code…",
      "successBody": "A code goes to your email or phone each time you sign in.",
      "successTitle": "2FA enabled!",
      "verify": "Verify & Enable",
      "verifying": "Verifying…"
    },
    "openMenuPhone": "Tap <strong>{{more}}</strong> at the bottom of the screen, then tap <strong>{{nav}}</strong>",
    "openMenuTablet": "Open the menu at the top of the screen, then tap <strong>{{nav}}</strong>",
    "patient": {
      "childName": "Child’s name",
      "cycleLength": "Length (days)",
      "cycleNumber": "Cycle #",
      "cycleStarted": "Started",
      "cycleToggle": "Track treatment cycles (optional)",
      "dateOfBirth": "Date of birth",
      "diagnosis": "Diagnosis",
      "diagnosisPlaceholder": "e.g. ALL, Neuroblastoma",
      "hospital": "Hospital / clinic",
      "intro": "{{companion}} uses what you share here to personalise gently. Only your family and TRF can see this.",
      "treatmentPhase": "Treatment phase"
    },
    "phase": {
      "active_treatment": "Active treatment",
      "diagnosis": "Diagnosis",
      "maintenance": "Maintenance",
      "off_treatment": "Off treatment",
      "other": "Other",
      "survivorship": "Survivorship"
    },
    "stepCounter": "Step {{step}} <muted>/ {{total}}</muted>",
    "steps": {
      "done": {
        "eyebrow": "Welcome aboard",
        "title": "You’re all set"
      },
      "firstRequest": {
        "eyebrow": "First task",
        "title": "Create your first task"
      },
      "patient": {
        "eyebrow": "Patient",
        "title": "Tell us about your child"
      },
      "security": {
        "eyebrow": "Security",
        "title": "Secure your account"
      },
      "voice": {
        "eyebrow": "{{companion}}’s voice",
        "title": "Choose {{companion}}’s voice"
      }
    },
    "voice": {
      "intro": "Pick the voice that feels right for you. You can change {{companion}} later from Settings.",
      "loading": "Loading voices…"
    },
    "worthKnowing": "Worth knowing"
  }
}
